import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function HantiRow() {
   return (
      <InputRangeRow
         titleProp={"H(anti)"}
         descriptionProp={"mm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0.0}
         maxProp={5.0}
         propertyNameProp={"hAnti"}
         errorDialogueProp={"0.0-5.0 only"}
         floatProp={true}
      />
   );
}
